import { Card, Paper, SimpleGrid, Stack, Text } from '@mantine/core'

import { Icons } from 'src/common/components'
import withErrorBoundaryAndPolicyCheck from 'src/v2/commons/HOC/ErrorBoundaryAndPolicyCheckHOC'
import { TBreadCrumbItems } from 'src/v2/commons/components/Breadcrumb'
import BasicTemplate from 'src/v2/commons/templates/BasicTemplate'

import { TeamLeadHubHook } from '../hook/team-lead-hub.hook'
import styles from './team-lead-hub.module.scss'

const breadCrumbItems: TBreadCrumbItems = [
  { title: 'Home' },
  { title: 'Administration Panel' },
]

export const TeamHubLeadView = () => {
  const { handleClinics } = TeamLeadHubHook()

  return (
    <BasicTemplate
      title="Administration Panel"
      breadCrumbItems={breadCrumbItems}
    >
      <Card shadow="lg" radius="lg" className={styles.defaultCard}>
        <SimpleGrid
          mt={36}
          cols={3}
          spacing="xl"
          c="var(--mantine-color-primary-5)"
        >
          <Paper
            withBorder
            radius="lg"
            shadow="none"
            mb={20}
            onClick={handleClinics}
          >
            <Stack align="center" justify="center" my={20}>
              <Icons.Clinics width="80px" height="80px" />
              <Text c="black">Clinics</Text>
            </Stack>
          </Paper>
        </SimpleGrid>
      </Card>
    </BasicTemplate>
  )
}

export default withErrorBoundaryAndPolicyCheck(
  TeamHubLeadView,
  'is_enable_administration_page',
  true,
)
